import SidebarPanel from './SidebarPanel';

export default SidebarPanel;
